import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NewHome from './views/NewHome.vue'
import store from './store/store-root'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/new',
      component: Home,
      children: [
        {
          path: '/',
          name: 'Index',
          component: () => import('./views/v1/Index.vue')
        },
        {
          path: '/equipmentExhibition',
          name: 'EquipmentExhibition',
          component: () => import('./views/v1/EquipmentExhibition.vue')
        },
        {
          path: '/electricityStatistics',
          name: 'ElectricityStatistics',
          component: () => import('./views/v1/ElectricityStatistics.vue')
        },
        {
          path: '/deviceSettings',
          name: 'DeviceSettings',
          component: () => import('./views/v1/DeviceSettings.vue')
        },
        {
          path: '/waterParameterDetail',
          name: 'WaterParameterDetail',
          component: () => import('./views/v1/WaterParameterDetail.vue')
        },
        {
          path: '/paramsSeeting',
          component: () => import('./views/v1/ParamsSeeting.vue'),
          children: [
            {
              path: '/',
              name: 'UpDownControl',
              component: () => import('./components/paramsSetting/UpDownControl.vue')
              // name: 'BoundControl',
              // component: () => import('./components/paramsSetting/BoundControl.vue')
            },
            {
              path: '/paramsSeeting/timeControl',
              name: 'TimeControl',
              component: () => import('./components/paramsSetting/TimeControl.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/',
      component: NewHome,
      // component: () => import('./views/NewHome.vue'),
      children: [
        {
          path: '/',
          name: 'equipmentControl',
          component: () => import('./views/v2/EquipmentControl.vue'),
          meta: { title: '设备控制' }
        },
        {
          path: '/machineShop',
          name: 'machineShop',
          component: () => import('./views/v2/MachineShop.vue')
        },
        {
          path: '/baseMap',
          name: 'baseMap',
          component: () => import('./views/v2/BaseMap.vue'),
          meta: { title: '设备定位' }
        },
        {
          path: '/electricityStatistic',
          name: 'electricityStatistic',
          component: () => import('./views/v2/ElectricityStatistic.vue')
        },
        {
          path: '/waterParameter',
          name: 'waterParameter',
          component: () => import('./components/v2/WaterParameter.vue'),
          meta: { title: '水质参数' }
        },
        {
          path: '/deviceEnergyHis',
          name: 'deviceEnergyHis',
          component: () => import('./components/v2/DeviceEnergyHis.vue'),
          meta: { title: '能耗分析' }
        },
        {
          path: '/autoControl',
          name: 'autoControl',
          component: () => import('./components/v2/AutoControl.vue'),
          meta: { title: '自动控制' }
        },
        {
          path: '/timeControl',
          name: 'timeControl',
          component: () => import('./components/v2/TimeControl.vue'),
          meta: { title: '时间控制' }
        },
        {
          path: '/basicList',
          name: 'basicList',
          component: () => import('./components/v2/BasicList.vue')
        },
        {
          path: '/basicAllList',
          name: 'basicAllList',
          component: () => import('./components/v2/BasicAllList.vue')
        },
        {
          path: '/liveMonitor',
          name: 'liveMonitor',
          component: () => import('./views/v2/LiveMonitor.vue')
        }

      ]
    },
    {
      path: '/v3',
      component: NewHome,
      // component: () => import('./views/NewHome.vue'),
      children: [
        {
          path: '/',
          name: 'equipmentControl',
          component: () => import('./views/v3/EquipmentControlV3.vue'),
          meta: { title: '设备控制' }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/demo',
      component: () => import('./components/ComponentDemo')
    },
    {
      path: '/logincallback',
      component: () => import('./views/LoginCallback.vue')
    }

  ]
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.loginUser && to.fullPath !== '/login') {
    await store.dispatch('getLoginUser')
    next()
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  if (to.fullPath.indexOf('login') > -1) return
  store.commit('setCurrentUrl', window.location.origin + to.fullPath)
})

export default router
